import type { PublicTeamMember } from './types';

// Interim public business contact for the team cards.
//
// IV's public API does NOT yet expose contact info (it strips email/phone as
// PII). Until `publicEmail`/`publicPhone`/`bookingUrl` are added to IV's
// publicInspector() output, we fall back to the PLACEHOLDER map below.
//
// ⚠️ The values for the network owner-operators are FAKE placeholders — David
// will set the real business contact in the IV backend. Resolution order:
//   1. the API field (member.publicEmail …) — wins once IV surfaces it
//   2. the PLACEHOLDER map (fake, by slug)
//   3. the Inspect Canada general line
const IC_EMAIL = 'fastreply@inspect.ca';
const IC_PHONE = '778-877-7540';
const DEFAULT_BOOKING = 'https://inspect.ca/schedule-inspection/';

// FAKE — replace in IV. Business contact for the network owner-operators.
const PLACEHOLDER: Record<string, { email?: string; phone?: string }> = {
  'shane-ballard': { email: 'shane@ballardhomeinspections.ca', phone: '604-555-0142' },
  'said-noori': { email: 'said@noorihomeinspections.ca', phone: '604-555-0173' },
  'ramien-boeve': { email: 'ramien@boevehomeinspections.ca', phone: '778-555-0119' },
};

export interface InspectorContact {
  businessName: string;
  email: string;
  phone: string;
  bookingUrl: string;
}

export function contactFor(m: PublicTeamMember): InspectorContact {
  const ph = PLACEHOLDER[m.slug] ?? {};
  return {
    businessName: m.companyName || 'Inspect Canada',
    email: m.publicEmail || ph.email || IC_EMAIL,
    phone: m.publicPhone || ph.phone || IC_PHONE,
    bookingUrl: m.bookingUrl || DEFAULT_BOOKING,
  };
}
